// 空函数
export const noon = (): any => {};
